import { FC } from 'react';

const AppIntegration: FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.54437 1.5H2.73438C2.04823 1.5 1.48438 2.06386 1.48438 2.75V8.62C1.48438 9.30859 2.04064 9.87 2.73438 9.87H8.54437C9.23296 9.87 9.79438 9.31374 9.79438 8.62V2.75C9.79438 2.06141 9.23811 1.5 8.54437 1.5ZM2.73438 2.5H8.54437C8.68376 2.5 8.79437 2.61164 8.79437 2.75V8.62C8.79437 8.75938 8.68273 8.87 8.54437 8.87H2.73438C2.59499 8.87 2.48438 8.75836 2.48438 8.62V2.75C2.48438 2.61614 2.60052 2.5 2.73438 2.5Z"
                fill="#00A3AD"
            />
            <path
                d="M21.2338 1.5H15.4238C14.7377 1.5 14.1738 2.06386 14.1738 2.75V8.62C14.1738 9.30859 14.7301 9.87 15.4238 9.87H21.2338C21.9224 9.87 22.4838 9.31374 22.4838 8.62V2.75C22.4838 2.06141 21.9276 1.5 21.2338 1.5ZM15.4238 2.5H21.2338C21.3732 2.5 21.4838 2.61164 21.4838 2.75V8.62C21.4838 8.75938 21.3722 8.87 21.2338 8.87H15.4238C15.2844 8.87 15.1738 8.75836 15.1738 8.62V2.75C15.1738 2.61614 15.29 2.5 15.4238 2.5Z"
                fill="#00A3AD"
            />
            <path
                d="M8.54437 14.1299H2.73438C2.04579 14.1299 1.48438 14.6861 1.48438 15.3799V21.2499C1.48438 21.9385 2.04064 22.4999 2.73438 22.4999H8.54437C9.23052 22.4999 9.79438 21.936 9.79438 21.2499V15.3799C9.79438 14.6913 9.23811 14.1299 8.54437 14.1299ZM2.73438 15.1299H8.54437C8.68376 15.1299 8.79437 15.2415 8.79437 15.3799V21.2499C8.79437 21.3837 8.67823 21.4999 8.54437 21.4999H2.73438C2.59499 21.4999 2.48438 21.3882 2.48438 21.2499V15.3799C2.48438 15.2405 2.59602 15.1299 2.73438 15.1299Z"
                fill="#00A3AD"
            />
            <path
                d="M18.334 14.1299C18.5794 14.1299 18.7836 14.3068 18.8259 14.54L18.834 14.6299V21.9999C18.834 22.276 18.6101 22.4999 18.334 22.4999C18.0885 22.4999 17.8844 22.323 17.842 22.0898L17.834 21.9999V14.6299C17.834 14.3537 18.0578 14.1299 18.334 14.1299Z"
                fill="#00A3AD"
            />
            <path
                d="M22.0145 17.8096C22.2907 17.8096 22.5145 18.0334 22.5145 18.3096C22.5145 18.555 22.3377 18.7592 22.1044 18.8015L22.0145 18.8096H14.6445C14.3684 18.8096 14.1445 18.5857 14.1445 18.3096C14.1445 18.0641 14.3214 17.86 14.5547 17.8176L14.6445 17.8096H22.0145Z"
                fill="#00A3AD"
            />
        </svg>
    );
};

export default AppIntegration;
